"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var svgs_1 = require("../../../assets/svgs");
var Loading = function (_a) {
    var _b = _a.fullScreen, fullScreen = _b === void 0 ? false : _b;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ style: fullScreen
                ? {
                    position: 'fixed',
                    height: '100vh',
                    width: '100vw',
                    background: '#250f7f',
                    top: '0',
                    left: '0',
                    zIndex: '2',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }
                : {} }, { children: [(0, jsx_runtime_1.jsx)("style", { children: " @keyframes lds-roller {\n              0% {\n                transform: rotate(0deg);\n              }\n              100% {\n                transform: rotate(360deg);\n              }\n            }" }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                        display: 'block',
                        position: 'relative',
                        '& div': {
                            animation: 'lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
                            transformOrigin: '40px 40px',
                        },
                        '& div:after': {
                            content: '" "',
                            display: 'block',
                            position: 'absolute',
                            width: '7px',
                            height: '7px',
                            borderRadius: '50%',
                            background: '#fff',
                            margin: '-4px 0 0 -4px',
                        },
                        '& div:nth-of-type(1)': {
                            animationDelay: '-0.036s',
                        },
                        '& div:nth-of-type(1):after': {
                            top: '63px',
                            left: '63px',
                        },
                        '& div:nth-of-type(2)': {
                            animationDelay: '-0.072s',
                        },
                        '& div:nth-of-type(2):after': {
                            top: '68px',
                            left: '56px',
                        },
                        '& div:nth-of-type(3)': {
                            animationDelay: '-0.108s',
                        },
                        '& div:nth-of-type(3):after': {
                            top: '71px',
                            left: '48px',
                        },
                        '& div:nth-of-type(4)': {
                            animationDelay: '-0.144s',
                        },
                        '& div:nth-of-type(4):after': {
                            top: '72px',
                            left: '40px',
                        },
                        '& div:nth-of-type(5)': {
                            animationDelay: '-0.18s',
                        },
                        '& div:nth-of-type(5):after': {
                            top: '71px',
                            left: '32px',
                        },
                        '& div:nth-of-type(6)': {
                            animationDelay: '-0.216s',
                        },
                        '& div:nth-of-type(6):after': {
                            top: '68px',
                            left: '24px',
                        },
                        '& div:nth-of-type(7)': {
                            animationDelay: '-0.252s',
                        },
                        '& div:nth-of-type(7):after': {
                            top: '63px',
                            left: '17px',
                        },
                        '& div:nth-of-type(8)': {
                            animationDelay: '-0.288s',
                        },
                        '& div:nth-of-type(8):after': {
                            top: '56px',
                            left: '12px',
                        },
                    } }, { children: [(0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)(svgs_1.ElphaLogoSvg, { width: "44", height: "44", viewBox: "5 5 80 70", style: {
                                background: '#fff',
                                borderRadius: '50%',
                                padding: '4px',
                                margin: '18px',
                            } })] }))] })) }));
};
exports.Loading = Loading;
